import JsSIP from 'jssip';
import LogRepository from "@/repositories/LogRepository";
import moment from "moment";
import TokenService from "@/helpers/token";
var testMode = false;
class OdsService {
  ua = null;
  configuration = null;
  connectOds(user) {
    if(!this.ua) {
      const socket = new JsSIP.WebSocketInterface(process.env.VUE_APP_WSS_ODS);
      socket.via_transport = 'tcp';
      const uri = `sip:${user.username}${process.env.VUE_APP_SIP_URI_ODS}`;
      this.configuration = {
        sockets: [socket],
        uri,
        password: user.password,
        session_timers: false,
        register_expires: 600,
        log: {
          builtinEnabled: false,
          level: 3,
          connector(level, category, label, content) {
            console.log('Log: ', content);
          },
        },
        socket: {
          uri,
          via_transport: 'auto',
        },
        use_preloaded_route: false,
        pcConfig: {
          rtcpMuxPolicy: 'negotiate',
          iceServers: [
            {
              urls: [],
            },
          ],
        },
      };
      this.ua = new JsSIP.UA(this.configuration);
      this.ua.on('connected', (e) => {
        console.log('connected', e);
      });
      this.ua.on('registered', (e) => {
        console.log('registered', e);
      });
      this.ua.on('disconnected', (e) => {
        console.log('disconnected', e);
      });
      this.ua.on('registrationFailed', (ev) => {
        console.log('registrationFailed', ev);
        this.configuration.uri = null;
        this.configuration.password = null;
      });
      // this.ua.start();
      // console.log(this.ua);
      // setTimeout(() => {
      //   console.log(this.ua.status);
      // }, 1000);
    }
    return this.ua;
  }
  saveLogsOdsConnect(user_id, user_name, tab_id, url, status, connection_result) {
    LogRepository.saveLogOds({
      connection_infomation: this.configuration,
      time_to_connect: moment().format('YYYY-MM-D HH:mm:ss'),
      user_id,
      user_name,
      tab_id,
      url,
      status,
      connection_result
    });
  }
  execCall(phoneNumber, eventHandlers) {
    const options = {
      eventHandlers,
      mediaConstraints: {
        audio: true,
        video: false,
      },
      pcConfig: {
        rtcpMuxPolicy: 'negotiate',
        iceServers: [],
      },
    };

    // Start call
    if(this.ua.status === 0) {
      this.ua.start();
    }
    const call = this.ua.call(phoneNumber, options);

    // Config sounds
    const remoteAudio = new window.Audio();
    remoteAudio.autoplay = true;
    remoteAudio.volume = 1;
    call.connection.addEventListener('addstream', (event) => {
      remoteAudio.srcObject = event.stream;
    });

    return call;
  }
  exampleCall() {
    const phoneNumber = '';

    const eventHandlers = {
      registrationFailed(e) {
        console.log('Thiết lập cuộc gọi không thành công: ', e);
      },
      progress(e) {
        console.log(`Bắt đầu gọi ${phoneNumber}, đợi trả lời!`, e);
      },
      failed(e) {
        console.log('Cuộc gọi bị lỗi', e);
        if (e.cause === 'Busy') {
          console.log('Busy', e);
        } else if (e.cause === 'Canceled') {
          console.log('Canceled', e);
        }
      },
      ended: (e) => {
        console.log('ended', e);
      },
      confirmed(e) {
        console.log('confirmed', e);
      },
    };

    this.execCall(phoneNumber, eventHandlers);
  }
}

const odsService = new OdsService();
export { odsService };
export default OdsService;
